var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var MovingStateMachine = function (root, model, editorModel) {
    var self = this;

    this.root = root;

    this.model = model;
    this.editorModel = editorModel;

    lib_core.StateMachine.call(this);

    this.startMovingTransition = this.addTransition("idle","moving",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        function(cEvent) {
            self.handle(cEvent);
            self.root.rec();
        }
    );

    this.addTransition("moving","moving",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        function(cEvent) {
            if(!self.model.isMoving()) {
                self.model.onElementMovingStart();
                self.model.isMoving(true);
            }
            var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
            var snapVec = self.editorModel.getSnappedMouseDisplacement(self.model._snapCollection, self.model._ignoreCollection);
            self.model.move(snapVec, keys);
        }
    );

    this.addTransition("moving","moving",
        function(cEvent) {
            return cEvent.isKeyPressed('alt') || cEvent.isKeyReleased('alt') ||
                   cEvent.isKeyPressed('S_shift') || cEvent.isKeyReleased('shift');
        },
        function(cEvent) {
            var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
            self.model.move(new lib_geometry.Coord(0,0), keys);
        }
    );

    this.addTransition("moving","idle",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP;
        },
        function(cEvent){
            self.model.onElementMovingStop();
            self.root.stopRec();
            self.model.isMoving(false);
            self.editorModel.clearSnap();
            self.handle(cEvent);
        }
    );

    this.addTransition("moving","idle",
        function(cEvent) {
            return (cEvent.isKeyPressed('escape') || cEvent.type().isGuiButton);
        },
        function(cEvent){
            self.model.onElementMovingStop();
            self.root.cancelRec();
            self.model.isMoving(false);
            self.editorModel.clearSnap();
            self.handle(cEvent);
        }
    );
};

lib_core.inherit(MovingStateMachine, lib_core.StateMachine);

module.exports = MovingStateMachine;
